import tree from "../../../../components/tree.vue";
import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import { domainName } from "../../../../utility/index";
import moment from "moment";

export default {
    name: "VehicleOperationRecords",
    components: {
        tree,
        iTable,
        IPagination
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            orgId: '',
            formInline: {
                numberType: '',
                number: ''
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('VehicleAnalysis.carId')
            }, {
                value: '2',
                label: this.$t('VehicleAnalysis.plateNum')
            },
            {
                value: '3',
                label: this.$t('VehicleAnalysis.driverNum')
            },
            {
                value: '4',
                label: this.$t('VehicleAnalysis.customNum')
            }],
            changeValue: [],
            height: '500',
            list: [],
            columns: [
                { prop: 'carId', label: this.$t('VehicleAnalysis.carId'), align: 'center', width: '120' },
                { prop: 'plateNum', label: this.$t('VehicleAnalysis.plateNum'), align: 'center', width: '120' },
                { prop: 'manufactureNum', label: this.$t('VehicleAnalysis.manufactureNum'), align: 'center', width: '130' },
                { prop: 'customNum', label: this.$t('VehicleAnalysis.customNum'), align: 'center', width: '130' },
                { prop: 'orgName', label: this.$t('VehicleAnalysis.carWorkGroupName'), align: 'center', width: '200' },
                { prop: 'driverName', label: this.$t('VehicleAnalysis.carWorkDriverName'), align: 'center', width: '150' },
                { prop: 'startTime', label: this.$t('VehicleAnalysis.carWorkStartTime'), align: 'center', width: '200' },
                { prop: 'endTime', label: this.$t('VehicleAnalysis.carWorkEndTime'), align: 'center', width: '200' },
                { prop: 'workTime', label: this.$t('VehicleAnalysis.carWorkDuration'), align: 'center', width: '120' },
            ],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
        }
    },
    created() {
        this.getDate()
    },
    methods: {
        getDate() {
            const endTime = moment().subtract(1, "day").format("YYYY-MM-DD");
            const startTime = moment().subtract(1, "month").format("YYYY-MM-DD");
            this.changeValue = [startTime, endTime];
        },
        changeTime() {
            this.currentPage = 1
            this.getList()
        },
        initQuery(item) {
            this.orgId = item.id
            this.getList()
        },
        nodeClick(val) {
            this.orgId = val.label
            this.getList()
        },
        getList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
                numberType: this.formInline.numberType,
                number: this.formInline.number
            };
            this.$store.dispatch('VehicleAnalysis/GET_SELECTCARWORKLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getList()
        },
        onClear() {
            this.formInline.numberType = ''
            this.formInline.number = ''
            this.getDate()
            this.currentPage = 1
            this.getList()
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportCarWorkList?orgId=${this.orgId}&selectType=${1}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}&numberType=${this.formInline.numberType}&number=${this.formInline.number}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportCarWorkList?orgId=${this.orgId}&selectType=${1}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}&numberType=${this.formInline.numberType}&number=${this.formInline.number}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getList()
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    },
};
